import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable()
export class CausesService {
    testMode: any = '?oi='
    constructor(private http: HttpClient) {
    }

    //#region Getters
    getSupportedNgo(): any {
        debugger
        return this.http.get(Configuration.apiUrl + 'Api/Ngo/GetSupportedNgosByStore')
    }
    getStatementFromBank(id: string): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/GetCauses?onlyActive=' + id)
    }
    getCauseIcons(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Customize/AdminGetCauseIcons')
    }
    getCauses(onlyActive): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/GetCauses?onlyActive=' + onlyActive)
    }
    getErroRakuten(): any {
        return this.http.get(Configuration.apiUrl + 'Api/NgoFinance/SalesRakuten?full=true&ngoUrl=&polenTest')
    }
    saveErroRakuten(item: any): any {
        return this.http.get(Configuration.apiUrl + 'Api/NgoFinance/SaveSalesRakuten')
    }
    getNgoContents(): any {
        return this.http.get(Configuration.apiUrl + 'Api/NgoTransparency/GetAllContents')
    }
    getOngsBoraDoar(): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/GetOngsBoraDoar')
    }
    getOngsCoronaVirus(): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/getOngsCoronaVirus')
    }
    getCauseIconsByCause(ngoUrl): any {
        return this.http.get(Configuration.apiUrl + 'Api/Customize/AdminGetCauseIconsByCause?ngoUrl=' + ngoUrl)
    }
    getNgos(active: boolean): any {
        //return this.http.get(Configuration.apiUrl + 'api/Ngo/GetSealNgos?fullInfos=' + fullInfos)
        //return this.http.get(Configuration.apiUrl + 'api/Ngo/getNgos?active=true')
        return this.http.get(Configuration.apiUrl + 'api/Ngo/getNgos?active=' + active)
    }
    getResumesNgos(active: boolean): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/getResumeNgos?active=' + active)
    }
    getNgosByBankStatementPending(): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/getNgosByBankStatementPending')
    }
    getListTransfeeraBatch(): any {
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminListTransfeeraBatch?seoName=')
    }
    getDepositsByBatchId(batchId): any {
        return this.http.get(Configuration.apiUrl + 'Api/Finance/AdminGetDepositsByBatchId?batchId=' + batchId)
    }
    getDepositsConsolidateInfos(status): any {
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminDepositsConsolidateInfos?status=' + status)
    }
    getBankStatementPending(status): any {
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminGetBankStatement?status=' + status)
    }
    getBankStatementsFromStoreAndNgo(seoUrl, ngoUrl): any {
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminGetBankStatementsFromStoreAndNgo?seoUrl=' + seoUrl + '&ngoUrl=' + ngoUrl)
    }
    getDepositById(depositId): any {
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminGetDepositById?depositId=' + depositId)
    }
    getUniqueMetricFromId(ngoUrl): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/GetUniqueMetricFromId?ngoUrl=' + ngoUrl)
    }
    getUsers(ngoUrl): any {
        return this.http.get(Configuration.apiUrl + 'Api/NgoPanel/Account/List?ngoUrl=' + ngoUrl + '&polenTest=true')
    }
    GetTransfeeraOpenBatches(): any {
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminGetTransfeeraOpenBatches')
    }
    getBackers(ocs, pluginUser): any {
        return this.http.get(Configuration.apiUrl + 'Api/NgoPanel/Backers?ngoUrl=' + ocs + '&polenTest=true&pluginUser=' + pluginUser)
    }
    //#endregion   

    //#region Saves
    saveBankInformation(ngo): any {
        console.log(JSON.stringify(ngo))
        return this.http.post(Configuration.apiUrl + 'Api/Ngo/SaveBankInformation', JSON.stringify(ngo), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
    saveNgoStatus(ngoUrl, active, isSealMember): any {
        console.log(Configuration.apiUrl + 'Api/Ngo/AdminSaveNgoStatus?ngoUrl=' + ngoUrl + '&active=' + active + '&isSealMember=' + isSealMember)
        return this.http.get(Configuration.apiUrl + 'Api/Ngo/AdminSaveNgoStatus?ngoUrl=' + ngoUrl + '&active=' + active + '&isSealMember=' + isSealMember)
    }
    saveUniqueMetric(metric): any {
        return this.http.post(Configuration.apiUrl + 'Api/Ngo/SaveUniqueMetric', JSON.stringify(metric), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
    saveCause(cause): any {
        return this.http.post(Configuration.apiUrl + 'Api/Ngo/SaveCause', JSON.stringify(cause), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
    saveNgoCategory(ngo): any {
        return this.http.post(Configuration.apiUrl + 'Api/Ngo/SaveNgoCategory', JSON.stringify(ngo), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
    saveAppraisalContent(content): any {
        return this.http.post(Configuration.apiUrl + 'Api/NgoTransparency/AppraisalContent', JSON.stringify(content), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
    //#endregion

    //#region Adminfunctions
    //usado para tentar repagar a Ong principalmente quando o bankstatement vem zero   
    adminRePaidNgo(organizationId, storeUrl): any {
        //console.log('api/Finance/AdminRePaidNgo?organizationId=' + organizationId + '&storeUrl=' + storeUrl)
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminRePaidNgo?organizationId=' + organizationId + '&storeUrl=' + storeUrl)
    }
    adminUploadBankStatementReceipt(depositId, formData, paid: boolean, notes: string): any {
        console.log('adminUploadBankStatementReceipt ->' + paid)
        console.log("api/Finance/adminUploadBankStatementReceipt?depositId=" + depositId + '&paid=' + paid + '&notes=' + notes)
        let apiUrl = Configuration.apiUrl + "api/Finance/adminUploadBankStatementReceipt?depositId=" + depositId + '&paid=' + paid + '&notes=' + notes;
        return this.http.post(apiUrl, formData)
    }

    adminSaveStatusDeposit(id, status, transferType, checkPaid): any {
        debugger
        console.log(Configuration.apiUrl + 'api/Finance/adminSaveStatusDeposit?depositId=' + id + '&status=' + status + '&transferType=' + transferType + '&sendEmail=' + checkPaid);
        return this.http.get(Configuration.apiUrl + 'api/Finance/adminSaveStatusDeposit?depositId=' + id + '&status=' + status + '&transferType=' + transferType + '&sendEmail=' + checkPaid);
    }

    adminChangeDepositTransferBatch(depositId, withdrawId): any {
        debugger
        console.log(Configuration.apiUrl + 'api/Finance/AdminChangeDepositTransferBatch?depositId=' + depositId + '&withdrawId=' + withdrawId);
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminChangeDepositTransferBatch?depositId=' + depositId + '&withdrawId=' + withdrawId);;
    }

    //transfere um bankstatement de um transferbatch para outro
    adminTransferDepositBetweenTransferBatch(depositId, batchId, newBatchId): any {
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminTransferDepositBetweenTransferBatch?bankStatementId=' + depositId + '&batchId=' + batchId + '&newBatchId=' + newBatchId)
    }

    adminDeleteDeposit(depositId): any {
        return this.http.get(Configuration.apiUrl + 'api/Finance/adminDeleteDeposit?id=' + depositId)
    }  

    AdminAddTransferToTransfeera(bankStatementId, batchId): any {
        debugger
        console.log('Api/deposit/AdminAddTransferToTransfeera?bankStatementId=' + bankStatementId + '&batchId=' + batchId)
        return this.http.get(Configuration.apiUrl + 'Api/deposit/AdminAddTransferToTransfeera?bankStatementId=' + bankStatementId + '&batchId=' + batchId)
    }
   
    AdminDeleteDepositFromTransferBatch(depositId, batchId): any {
        debugger
        console.log('Api/Finance/AdminDeleteDepositFromTransferBatch?depositId=' + depositId + '&batchId=' + batchId)
        return this.http.get(Configuration.apiUrl + 'Api/Finance/AdminDeleteDepositFromTransferBatch?depositId=' + depositId + '&batchId=' + batchId)
    }
    adminSaveCauseIcons(cause): any {
        return this.http.post(Configuration.apiUrl + 'Api/Customize/AdminSaveCauseIcons', JSON.stringify(cause), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
    //#endregion

    //#region CRUDTransfeeraBatch
    CloseTransfeeraBatch(batchId): any {
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminCloseTransfeeraBatch?batchId=' + batchId)
    }

    DeleteTransfeeraBatch(batchId): any {
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminDeleteTransfeeraBatch?batchId=' + batchId)
    }

    CreateTransfeeraBatch(): any {
        return this.http.get(Configuration.apiUrl + 'api/Finance/AdminCreateTransfeeraBatch')
    }
    //#endregion

    searchNgos(onlyActive, doubleVerified, typeSearch, searchTerm, page, pageSize): any {
        return this.http.get(Configuration.apiUrl + `api/Ngo/searchNgos
        ?onlyActive=${onlyActive}
        &doubleVerified=${doubleVerified}
        &typeSearch=${typeSearch}
        &searchTerm=${searchTerm}
        &page=${page}
        &pageSize=${pageSize}`)
    }
    changeNgosOfStore(storeUrl, ngoUrlList): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/Ngo/ChangeNgoOfStore', JSON.stringify({ storeUrl, ngoUrlList }), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
}